export default "__VITE_ASSET__C$wxFCHu__"